import React, { FC, useContext }   from 'react';
import { Button, Header, Segment } from 'semantic-ui-react';

import { TextLink }                        from '../../../../components/display/TextLink';
import { DashboardProjectListItemContext } from './ProjectListItem';
import { SemanticUIColor }                 from '../../../../../types';
import { RolePolicyType }                  from '../../../../../services/RoleAccessService';
import { useCurrentUser, useFeatureFlags } from '../../../../../hooks';

interface Props {}

const defaultProps: Props = {}

const PastProjectMessage: FC<Props> = ( props ) => {

    let { hasProjectRoleAccessTo } = useCurrentUser(),
        featureFlags               = useFeatureFlags(),
        { operations, project }    = useContext( DashboardProjectListItemContext );

    // Permission Checks not in LD
    let canUpdateSettings      = hasProjectRoleAccessTo( project.id, [ RolePolicyType.PROJECT_MANAGE_ACCESS ] ),
        canViewProjectPlanning = featureFlags.permissionProjectPlanningView;

    return (

            <>

                <Header textAlign={ 'center' } as={ 'h3' } content={ 'No upcoming activities or hires!' } color={ SemanticUIColor.PURPLE }/>

                <p className={ 'text-center margin-md-bottom' }>
                    <strong>Today's date is past the Launch Readiness Date set for your project,<br/>so there is nothing coming up to show here.</strong>

                    { canViewProjectPlanning && canUpdateSettings && (
                            <>
                                <br/>
                                <br/>
                                If you need to adjust your Launch Readiness Date,<br/>you can do so with <strong><TextLink onClick={ operations.manageProject.callback }>project settings</TextLink></strong>.
                            </>
                    ) }
                </p>

            </>
    );
};

PastProjectMessage.defaultProps = defaultProps;

export { PastProjectMessage }
